import React, { useState } from "react";
import styled from "styled-components";

// Important: For the expansion animation to work correctly, the max-height value should match the actual height of the footer component.
const Footer = styled.div`
    transition: max-height 0.5s cubic-bezier(0.22, 1, 0.36, 1), visibility 0.5s cubic-bezier(0.22, 1, 0.36, 1);
    max-height: ${(props) => (props.$isExpanded ? props.$maxHeight : "0")};
    visibility: ${(props) => (props.$isExpanded ? "visible" : "hidden")};
    ${(props) => !props.$isExpanded && "overflow: hidden;"}
`;

const Divider = styled.hr`
    border: 0;
    border-color: ${({ $color }) => ($color ? $color : "inherit")};
    border-style: solid;
    border-bottom-width: 1px;
    width: 100%;
`;

const ExpandingBox = ({
    children,
    footer,
    footerHeight = "100px",
    style,
    className,
    hasDivider = false,
    dividerColor,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!footer) return children;

    return (
        <div
            style={style}
            className={className}
            onMouseLeave={() => setIsExpanded(false)}
            onMouseOver={(e) => {
                const tooltipEl = document.querySelector('[role="tooltip"]');
                if (tooltipEl && tooltipEl.contains(e.target)) {
                    setIsExpanded(false);
                }
            }}
        >
            <div onMouseOver={() => setIsExpanded(true)}>{children}</div>
            <Footer $isExpanded={isExpanded} $maxHeight={footerHeight}>
                {isExpanded && hasDivider && (
                    <div>
                        <Divider $color={dividerColor} />
                    </div>
                )}
                {footer}
            </Footer>
        </div>
    );
};
export default ExpandingBox;
